import React from 'react';
import HelpTip from "../../../../../components/HelpTip";
import AuthService from "../../../../../services/AuthService";
import LoadingSpinner from "../../../../../components/LoadingSpinner";
import moment from "moment/moment";

export default class CommentsSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: (props.comments) ? props.comments.comments : '',
            isEditMode: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: (nextProps.comments) ? nextProps.comments.comments : '',
        }, () => { console.log(this.state) });
    }

    convertUTCToLocalTime = (dateString) => {
        let date = new Date(dateString);
        const milliseconds = Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
        );
        const localTime = new Date(milliseconds);
        let cd = localTime.getFullYear() + "-" + (localTime.getMonth() + 1) + "-" + localTime.getDate() + " " + localTime.getHours() + ":" + localTime.getMinutes() + ":" + localTime.getSeconds();
        return moment(cd).format('DD-MM-YYYY h:mm A');
    };

    _onEdit = () => {
        this.setState({
            isEditMode: true
        });
    };

    _onCancel = () => {
        this.setState({
            isEditMode: false
        });
    };

    _onSave = () => {
        this.props.onSave(this.state.value, () => {
            this.setState({
                isEditMode: false
            });
        });
    };

    _onDelete = () => {
        this.props.onDelete(() => {
            this.setState({
                isEditMode: false
            });
        });
    };

    _onChange = (event) => {
        this.setState({
            value: event.target.value
        });
    };

    _renderComment = () => {
        if (this.state.isEditMode) {
            return (
                <div className="relative">
                    {this.props.isLoading && <div className="loading">
                        <LoadingSpinner isVisible={this.props.isLoading} />
                    </div>}
                    <textarea autoFocus className="margin--20--bot text--dark" value={this.state.value} onChange={this._onChange} disabled={this.props.isLoading} />
                    <button className="btn btn--small btn--color margin--10--right" disabled={this.props.isLoading} onClick={this._onSave}>Save</button>
                    <button className="btn btn--small" disabled={this.props.isLoading} onClick={this._onCancel}>Cancel</button>
                </div>
            );
        }
        const isAdmin = AuthService.isAdmin();
        return (
            <ul className="list--box list--info">
                <li>
                    {this.state.value === '' && <p><em>None.</em></p>}
                    {this.state.value !== '' && <p className="text--linebreak text--dark margin--20--bot">{this.state.value}</p>}
                    {AuthService.can('Edit comments') && this.props.comments &&
                        <p className="text--14">Last updated by {this.props.comments.lastAuthor}, {this.convertUTCToLocalTime(this.props.comments.updatedAt)}.</p>
                    }
                    {/* {(isAdmin || AuthService.getAdminType() == 3) && */}
                    {AuthService.can('Edit comments') &&
                        <button className="btn btn--small btn--color margin--20--right" onClick={this._onEdit}>Edit</button>
                    }
                    {/* {(isAdmin || AuthService.getAdminType() == 3) && this.state.value != '' && */}
                    {AuthService.can('Delete comments') && this.state.value != '' &&
                        <button className="btn btn--small btn--color margin--20--right" onClick={this._onDelete}>Delete</button>
                    }
                </li>
            </ul>
        )
    };

    render() {
        return (
            AuthService.can('Comments') &&
            <div className="margin--30--bot relative">
                <h3 className="sub-title margin--10--bot">Comments</h3>
                <HelpTip><span>Only editable by administrators.</span></HelpTip>
                {this._renderComment()}
            </div>
        );
    }
};
